<template>
  <div class="sidebar"
       :class="{ 'sidebar--mini': $store.state.sidebar, 'sidebar--open': $store.state.sidebarOpen && sidebarOpen}"
       @mouseenter="showMenu = true"
       @mouseleave="showMenu = false"
  >
    <div class="sidebar__top">
      <router-link :to="{ name: 'profile' }" class="sidebar__logo">
        <img src="@/assets/img/club-ruy-logo.svg" alt="main logo" />
        <img src="@/assets/img/sidebar/main-leaf.svg" alt="main logo" />
      </router-link>
      <button
        class="sidebar__toggler"
        :class="{ 'is-hidden': $store.state.sidebar }"
        type="button"
        @click="toggleSidebar"
      ></button>
      <button
        @click="sidebarMobileClose"
        class="sidebar__close"
      >
      </button>
    </div>
    <div class="sidebar__user">
      <div class="user" :class="{ 'user--hide': $store.state.sidebar && !showMenu }">
        <router-link
          :to="{ name: 'profile' }"
          class="user__info"
        >
          <div class="user__photo">
            <img v-if="$store.state.meProfile.crop_url" :src="$store.state.meProfile.crop_url" alt="User photo">
            <img v-else src="@/assets/img/user-empty-photo.svg" alt="User slug">
          </div>
          <div class="user__wrap">
            <span v-if="$store.state.meProfile.first_name" class="user__name">
              {{ $store.state.meProfile.first_name }} {{ $store.state.meProfile.last_name }}
            </span>
            <div class="user__id"><b>ID:</b>{{ $store.state.meProfile.id }}</div>
          </div>
        </router-link>
        <button
          @click="logout"
          class="user__logout"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 8.25V6.375C15 5.87772 14.8025 5.40081 14.4508 5.04917C14.0992 4.69754 13.6223 4.5 13.125 4.5H4.125C3.62772 4.5 3.15081 4.69754 2.79917 5.04917C2.44754 5.40081 2.25 5.87772 2.25 6.375V17.625C2.25 18.1223 2.44754 18.5992 2.79917 18.9508C3.15081 19.3025 3.62772 19.5 4.125 19.5H13.125C13.6223 19.5 14.0992 19.3025 14.4508 18.9508C14.8025 18.5992 15 18.1223 15 17.625V15.75" stroke="#323F4B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 8.25L21.75 12L18 15.75" stroke="#323F4B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.95312 12H21.75" stroke="#323F4B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="sidebar__menu">
      <Menu :show="showMenu" :mobileShow="$store.state.sidebarOpen"/>
      <div class="sidebar__line"></div>
      <div class="sidebar__block">
<!--        <div class="sidebar__title">Техническая поддержка</div>-->
<!--        <div class="sidebar__links">-->
<!--          <a :href="link.url" class="sidebar__link" v-for="link in links" :key="link.id">-->
<!--            <img :src="require('@/assets/img/sidebar/' + link.icon)" :alt="link.icon">-->
<!--            <span>{{ link.text }}</span>-->
<!--          </a>-->
<!--        </div>-->
        <template v-if="$store.state.auth.isUserLoggedIn() && $store.state.meProfile.user_permissions.is_admin">
          <div class="sidebar__title">Сервисы</div>
          <div class="sidebar__links">
            <div class="sidebar__link">
              <img src="@/assets/img/sidebar/sms-icon.svg" alt="">
              <span>Баланс: {{ sysInfo.balance_sms }} &#8381;</span>
            </div>
            <div class="sidebar__link">
              <img src="@/assets/img/sidebar/dadata-icon.svg" alt="">
              <span>Запросы: {{ sysInfo.balance_dadata }}</span>
            </div>
          </div>
          <div class="sidebar__line sidebar__line--100"></div>
        </template>
        <div class="sidebar__text">
          Автоматизированная информационная система «Клуб РСМ»
        </div>
<!--        <div class="sidebar__text sidebar__text&#45;&#45;small-m">-->
<!--          <a href="https://apps.apple.com/ru/app/%D0%BA%D0%BB%D1%83%D0%B1-%D1%80%D1%81%D0%BC/id1561582436" target="_blank" class="sidebar__icon">-->
<!--            <svg width="171" height="57" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M160.454 0H10.445C1.483 0 0 3.085 0 10.428v36.228C0 53.982 3.066 57 10.428 57h150.026C167.833 57 171 53.966 171 46.64V10.427C171 3.085 167.833 0 160.454 0z" fill="#000"/><path fill-rule="evenodd" clip-rule="evenodd" d="M44.578 35.474c-.86 1.894-1.28 2.749-2.376 4.425-1.55 2.347-3.723 5.265-6.436 5.281-2.409.017-3.015-1.559-6.284-1.542-3.251.017-3.942 1.56-6.334 1.542-2.696-.016-4.768-2.665-6.318-5.012-4.33-6.555-4.785-14.25-2.106-18.34 1.904-2.901 4.886-4.611 7.7-4.611 2.863 0 4.666 1.559 7.025 1.559 2.29 0 3.69-1.56 7.008-1.56 2.51 0 5.155 1.359 7.042 3.706-6.183 3.403-5.172 12.204 1.078 14.552z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33.964 14.635c1.196-1.543 2.122-3.705 1.785-5.918-1.97.134-4.262 1.374-5.61 3-1.213 1.476-2.224 3.655-1.836 5.784 2.14.05 4.363-1.223 5.66-2.866zM155.737 38.559h-8.693c.033 1.174.454 2.196 1.263 2.884.725.603 1.685.888 2.847.888 1.298 0 2.46-.218 3.521-.637l.455 1.995c-1.23.536-2.695.788-4.38.788-2.022 0-3.605-.587-4.768-1.777-1.145-1.19-1.735-2.766-1.735-4.761 0-1.962.539-3.588 1.617-4.895 1.129-1.392 2.662-2.08 4.566-2.08 1.887 0 3.302.688 4.262 2.08.775 1.106 1.163 2.53 1.163 4.14-.017.52-.051 1.04-.118 1.375zm-12.366-4.761c-.169-.05-.623-.067-.944-.067-1.027 0-1.819.385-2.375 1.14-.489.67-.741 1.525-.741 2.565v6.655h-2.864v-8.75c0-1.493-.068-2.817-.118-4.158h2.527l.101 2.682h.084c.303-.838.792-1.593 1.449-2.112.64-.47 1.365-.721 2.123-.721.269 0 .573-.017.741.017v2.749h.017zm-10.479 8.768c-1.196 1.307-2.797 1.978-4.785 1.978-1.92 0-3.453-.637-4.582-1.894-1.129-1.258-1.702-2.867-1.702-4.778 0-2.012.59-3.655 1.752-4.946 1.18-1.29 2.746-1.928 4.734-1.928 1.921 0 3.454.62 4.617 1.895 1.112 1.223 1.667 2.816 1.667 4.744.017 2.012-.555 3.638-1.701 4.929zm-11.928-9.036h-3.032v6.203c0 1.609.505 2.397 1.634 2.397.522 0 .909-.034 1.246-.134l.068 2.18c-.573.217-1.331.318-2.258.318-1.145 0-2.072-.336-2.712-1.04-.657-.687-.994-1.86-.994-3.504v-6.42h-1.853v-2.347h1.853v-2.297l3.032-.855v3.152h3.033v2.347h-.017zm-10.193 9.405c-1.179 1.056-2.83 1.575-4.936 1.575-1.954 0-3.504-.368-4.683-1.123l.674-2.397a8.161 8.161 0 004.178 1.123c1.095 0 1.937-.251 2.56-.737.607-.487.91-1.14.91-1.979 0-.72-.253-1.34-.741-1.844-.506-.503-1.331-.955-2.494-1.391-3.167-1.174-4.75-2.884-4.75-5.147 0-1.475.556-2.7 1.667-3.638 1.112-.939 2.595-1.408 4.448-1.408 1.651 0 3.016.285 4.111.855l-.725 2.347c-1.027-.553-2.173-.822-3.47-.822-1.028 0-1.82.252-2.392.738-.489.453-.725.99-.725 1.626 0 .704.27 1.291.826 1.76.488.42 1.364.889 2.628 1.392 1.567.62 2.695 1.358 3.437 2.196.724.838 1.095 1.878 1.095 3.118-.017 1.543-.556 2.8-1.618 3.756zm-16.746-.101c-1.078 1.14-2.426 1.71-4.026 1.71-1.719 0-2.881-.62-3.724-1.844v6.924h-2.864v-14.1c0-1.39-.05-2.665-.118-4.341h2.544l.169 2.179h.05c.978-1.509 2.443-2.347 4.398-2.347 1.533 0 2.83.587 3.858 1.81 1.027 1.208 1.55 2.8 1.55 4.778-.034 2.213-.624 3.94-1.837 5.231zm-14.337 0c-1.078 1.14-2.426 1.71-4.026 1.71-1.736 0-2.881-.62-3.724-1.844v6.924h-2.864v-14.1c0-1.39-.067-2.665-.134-4.341h2.544l.168 2.179h.05c.978-1.509 2.443-2.347 4.415-2.347 1.533 0 2.813.587 3.858 1.81 1.027 1.208 1.55 2.8 1.55 4.778-.017 2.213-.624 3.94-1.837 5.231zm-15.5 1.257l-1.684-5.197h-5.897l-1.617 5.197h-2.999l5.813-17.938h3.605l5.863 17.938h-3.083zm86.006-11.131c-.943 0-1.718.486-2.308 1.257-.489.62-.775 1.308-.859 2.314h6.031c.017-1.006-.168-1.677-.556-2.297-.488-.788-1.263-1.274-2.308-1.274zm-90.655-4.292h-.05c-.186.838-.472 1.961-.86 3.453l-1.5 4.762h4.853l-1.517-4.762c-.168-.486-.488-1.777-.926-3.453zm29.954 4.627c-.724 0-1.364.235-1.937.704a3.228 3.228 0 00-1.146 1.86c-.084.353-.135.655-.135.89v2.145c0 .94.304 1.744.876 2.398.573.637 1.348.972 2.275.972 1.095 0 1.954-.42 2.56-1.257.607-.838.91-1.945.91-3.32 0-1.257-.286-2.296-.859-3.118-.64-.838-1.482-1.274-2.544-1.274zm38.715-.184c-1.162 0-2.038.52-2.645 1.542-.522.855-.775 1.878-.775 3.118 0 1.19.253 2.213.775 3.068.624 1.023 1.5 1.542 2.629 1.542 1.095 0 1.971-.52 2.594-1.575.539-.855.809-1.895.809-3.085s-.253-2.213-.775-3.068c-.607-1.04-1.483-1.542-2.612-1.542zm-53.052.184c-.707 0-1.364.235-1.937.704-.59.486-.96 1.09-1.146 1.86-.084.353-.135.655-.135.89v2.145c0 .94.287 1.744.876 2.398.573.637 1.331.972 2.275.972 1.095 0 1.954-.42 2.56-1.257.607-.838.91-1.945.91-3.32 0-1.257-.286-2.296-.859-3.118-.64-.838-1.482-1.274-2.544-1.274z" fill="#fff"/><path d="M60.886 12.422v7.946l.893.034-.1 3.604H60.38l-.101-2.297h-5.66l-.102 2.297h-1.297l-.084-3.604.741-.034c.354-.653.69-1.324.893-2.062.286-.989.404-2.129.404-3.453v-2.431h5.712zm-4.127 2.85c0 1.274-.135 2.414-.438 3.386a8.972 8.972 0 01-.69 1.66h3.554v-6.505h-2.426v1.459zM69.394 18.307c0 2.464-1.752 3.57-3.47 3.57-1.904 0-3.387-1.307-3.387-3.453 0-2.213 1.449-3.554 3.488-3.554 2.021-.016 3.369 1.392 3.369 3.437zm-5.088.067c0 1.291.64 2.28 1.685 2.28.977 0 1.65-.956 1.65-2.297 0-1.056-.47-2.246-1.633-2.246-1.213-.017-1.702 1.14-1.702 2.263zM75.763 21.51c-.354.167-1.061.351-1.92.351-2.106 0-3.47-1.341-3.47-3.42 0-2.012 1.38-3.587 3.756-3.587.623 0 1.264.134 1.651.318l-.303 1.274a3.042 3.042 0 00-1.28-.268c-1.298 0-2.073.956-2.073 2.18 0 1.374.893 2.162 2.072 2.162.59 0 1.011-.117 1.348-.268l.22 1.257zM82.232 15.004v1.308h-2.021v5.398h-1.702v-5.398h-2.022v-1.308h5.745zM84.557 15.004l1.213 3.604c.134.42.27.922.37 1.308h.034c.118-.386.236-.888.354-1.324l1.061-3.588h1.836l-1.684 4.577c-.927 2.515-1.55 3.621-2.359 4.308-.657.587-1.365.822-1.786.872l-.387-1.442c.286-.067.657-.218.994-.469.32-.201.69-.604.926-1.056.068-.118.118-.218.118-.302 0-.067-.016-.168-.1-.335l-2.46-6.17h1.87v.017zM96.367 15.004v6.723H94.65v-5.415h-2.544v5.398h-1.702v-6.706h5.964zM99.87 15.004v2.565h2.612v-2.565h1.701v6.723h-1.701v-2.834h-2.611v2.834h-1.702v-6.723h1.702zM112.405 18.307c0 2.464-1.752 3.57-3.471 3.57-1.904 0-3.386-1.307-3.386-3.453 0-2.213 1.449-3.554 3.487-3.554 2.022-.016 3.37 1.392 3.37 3.437zm-5.088.067c0 1.291.64 2.28 1.685 2.28.977 0 1.651-.956 1.651-2.297 0-1.056-.472-2.246-1.635-2.246-1.213-.017-1.701 1.14-1.701 2.263zM116.666 15.088c.505-.084 1.516-.168 2.46-.168 1.128 0 3.184.15 3.184 1.693 0 .855-.657 1.341-1.382 1.492v.034c.994.15 1.685.704 1.685 1.643 0 1.844-2.443 2.028-3.791 2.028-.842 0-1.752-.05-2.139-.1v-6.622h-.017zm1.651 5.616c.27.033.489.033.826.033.775 0 1.718-.2 1.718-.989 0-.754-.741-1.006-1.82-1.006h-.741v1.962h.017zm0-2.984h.708c.876 0 1.6-.252 1.6-.889 0-.536-.472-.821-1.482-.821-.337 0-.556.033-.826.05v1.66z" fill="#fff"/></svg>-->
<!--          </a>-->
<!--        </div>-->
<!--        <div class="sidebar__text">-->
<!--          <a href="https://play.google.com/store/apps/details?id=com.antonovgroup.ruyclub" target="_blank" class="sidebar__icon">-->
<!--            <svg width="170" height="57" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M159.515 0H10.385C1.473 0 0 3.085 0 10.428v36.228C0 53.982 3.048 57 10.367 57h149.148C166.851 57 170 53.966 170 46.64V10.427C170 3.085 166.851 0 159.515 0z" fill="#000"/><path d="M14.588 11.316a1.002 1.002 0 00-.687.956v33.244c0 .453.285.805.67.956l17.637-17.57-17.62-17.586z" fill="#00D6FF"/><path d="M37.183 23.94L15.41 11.4a1.054 1.054 0 00-.838-.083l17.637 17.57 4.974-4.946z" fill="#00F076"/><path d="M15.41 46.388l21.773-12.54-4.974-4.962-17.637 17.586c.268.084.57.084.838-.084z" fill="#FF3A44"/><path d="M37.2 33.848l7.084-4.073c.67-.386.67-1.358 0-1.744l-7.102-4.09-4.974 4.945 4.991 4.962z" fill="#FFD000"/><path d="M84.046 32.675c-3.116 0-5.594 2.347-5.594 5.599 0 3.118 2.462 5.6 5.594 5.6s5.594-2.348 5.594-5.6c-.017-3.386-2.479-5.6-5.594-5.6zm0 8.851c-1.692 0-3.116-1.425-3.116-3.386 0-1.945 1.424-3.387 3.116-3.387 1.691 0 3.115 1.308 3.115 3.387 0 1.945-1.44 3.386-3.115 3.386zm-12.093-8.851c-3.115 0-5.594 2.347-5.594 5.599 0 3.118 2.462 5.6 5.594 5.6s5.594-2.348 5.594-5.6c0-3.386-2.479-5.6-5.594-5.6zm0 8.851c-1.692 0-3.115-1.425-3.115-3.386 0-1.945 1.424-3.387 3.115-3.387 1.692 0 3.115 1.308 3.115 3.387 0 1.945-1.423 3.386-3.115 3.386zm-14.42-7.158v2.347h5.593c-.133 1.308-.653 2.347-1.306 2.984-.787.788-2.077 1.693-4.288 1.693-3.5 0-6.113-2.732-6.113-6.236 0-3.504 2.73-6.237 6.113-6.237 1.826 0 3.25.788 4.288 1.694l1.692-1.694c-1.424-1.307-3.25-2.347-5.846-2.347-4.672 0-8.709 3.906-8.709 8.584 0 4.677 4.02 8.583 8.71 8.583 2.595 0 4.421-.788 5.979-2.464 1.557-1.56 2.076-3.772 2.076-5.465 0-.52 0-1.04-.133-1.425l-8.057-.017zm58.989 1.81c-.52-1.307-1.826-3.503-4.673-3.503-2.864 0-5.192 2.213-5.192 5.599 0 3.118 2.344 5.6 5.46 5.6 2.462 0 4.019-1.56 4.555-2.465l-1.825-1.308c-.654.906-1.424 1.56-2.73 1.56-1.307 0-2.077-.52-2.73-1.694l7.403-3.118-.268-.67zm-7.537 1.828c0-2.079 1.691-3.253 2.864-3.253.904 0 1.825.52 2.077 1.174l-4.941 2.079zm-6.114 5.331h2.479V27.075h-2.462v16.262h-.017zm-3.885-9.489c-.654-.654-1.692-1.307-2.982-1.307-2.73 0-5.326 2.464-5.326 5.599 0 3.135 2.462 5.465 5.326 5.465 1.307 0 2.345-.654 2.864-1.307h.134v.788c0 2.078-1.172 3.252-2.98 3.252-1.425 0-2.463-1.04-2.731-1.945l-2.077.905c.653 1.425 2.211 3.253 4.941 3.253 2.864 0 5.192-1.693 5.192-5.717v-9.891h-2.345l-.016.905zm-2.864 7.678c-1.692 0-3.116-1.425-3.116-3.386 0-1.945 1.424-3.387 3.116-3.387 1.691 0 2.98 1.425 2.98 3.387 0 1.945-1.289 3.386-2.98 3.386zm31.705-14.45h-5.845v16.261h2.462v-6.12h3.383c2.73 0 5.326-1.944 5.326-5.079s-2.596-5.063-5.326-5.063zm.134 7.812h-3.517v-5.6h3.517c1.826 0 2.864 1.56 2.864 2.733-.151 1.442-1.189 2.867-2.864 2.867zm14.94-2.347c-1.826 0-3.635.787-4.288 2.464l2.211.905c.519-.905 1.306-1.173 2.211-1.173 1.306 0 2.462.788 2.596 2.078v.135c-.385-.269-1.424-.654-2.462-.654-2.345 0-4.673 1.307-4.673 3.638 0 2.213 1.943 3.638 4.02 3.638 1.691 0 2.462-.788 3.115-1.56h.134v1.308h2.345v-6.236c-.285-2.85-2.479-4.544-5.209-4.544zm-.268 8.985c-.787 0-1.943-.385-1.943-1.425 0-1.307 1.424-1.693 2.596-1.693 1.039 0 1.558.268 2.211.52-.268 1.542-1.558 2.598-2.864 2.598zm13.65-8.583l-2.73 7.024h-.134l-2.864-7.024h-2.596l4.288 9.891-2.462 5.449h2.462l6.632-15.34h-2.596zm-21.84 10.394h2.462V27.075h-2.462v16.262zM55.873 19.817c-.67.771-1.457 1.14-2.412 1.14-.854 0-1.574-.285-2.16-.872-.587-.57-.871-1.341-.871-2.263 0-.939.301-1.693.87-2.263a2.995 2.995 0 012.161-.872c.922 0 1.625.318 2.16.989l.118.15.988-.955-.117-.117c-.804-.939-1.876-1.408-3.165-1.408-1.257 0-2.328.436-3.183 1.29-.854.856-1.29 1.928-1.29 3.203 0 1.274.436 2.347 1.29 3.202.855.855 1.926 1.29 3.183 1.29.686 0 1.34-.133 1.926-.418a4.113 4.113 0 001.474-1.124l.1-.117-.971-.973-.1.118zM67.464 13.58l-3.082 8.181-3.098-4.442 3.031-3.504v-.235H62.64l-3.517 3.973V13.58h-1.34v8.55h1.34v-2.498l1.122-1.257 2.663 3.755h2.848l.804-2.18h3.232l.804 2.18h1.54l-3.232-8.55h-1.44zm1.842 5.03h-2.26l1.138-3.135 1.122 3.135zM76.877 16.866c-.335.486-.938.738-1.642.738-.485 0-.887-.134-1.139-.386-.268-.252-.402-.62-.402-1.107v-2.53h-1.34v2.732c0 .804.252 1.442.788 1.928.536.47 1.189.704 1.976.704.72 0 1.323-.201 1.809-.62l-.034.268v3.537h1.508v-8.55h-1.508v3.286h-.016zM80.729 19.615V13.58h-1.34v8.55h1.373l3.986-6.37v6.37h1.34v-8.55h-1.54l-3.82 6.035zM92.184 17.67c.252-.15.453-.351.603-.586.218-.335.335-.704.335-1.14 0-.688-.25-1.258-.77-1.71-.503-.453-1.106-.654-1.792-.654h-3.132v8.55h3.316c.72 0 1.34-.235 1.876-.704.536-.47.804-1.09.804-1.81 0-.487-.15-.906-.436-1.275a2.213 2.213 0 00-.804-.67zm-.77-.921c-.218.234-.486.352-.838.352h-1.808v-2.18h1.859c.335 0 .603.084.804.319.2.235.301.47.301.754 0 .268-.1.52-.318.755zm.234 3.671c-.217.252-.502.369-.87.369h-2.01v-2.347h1.976c.385 0 .67.1.904.352.235.251.352.503.352.805-.017.301-.117.553-.352.821zM96.74 13.58l-3.233 8.55h1.54l.805-2.18h3.232l.804 2.18h1.541l-3.233-8.55H96.74zm1.859 5.03h-2.262l1.14-3.135 1.121 3.135zM105.299 13.245c.436 0 .788-.151 1.106-.47.318-.318.452-.704.452-1.157V11.4h-1.172v.218c0 .134-.017.252-.101.352-.084.101-.167.134-.301.134a.405.405 0 01-.319-.134.53.53 0 01-.117-.352V11.4h-1.172v.218c0 .453.151.839.486 1.157.335.319.703.47 1.138.47zM103.323 19.615l.017-1.073V13.58H102v8.55h1.34l4.02-6.37v6.37h1.34v-8.55h-1.575l-3.802 6.035zM109.369 14.921h2.345v7.21h1.507v-7.21h2.178v-1.34h-6.03v1.34zM116.236 22.13h5.192V20.79h-3.684v-2.347h3.349V17.1h-3.349v-2.18h3.684v-1.34h-5.192v8.55zM130.657 18.325a2.262 2.262 0 00-.787-.654c.251-.151.452-.352.603-.587.218-.335.335-.704.335-1.14 0-.688-.251-1.258-.771-1.71-.502-.453-1.105-.654-1.792-.654h-3.132v8.55h3.3c.72 0 1.34-.235 1.876-.704.536-.47.804-1.09.804-1.81a2.298 2.298 0 00-.436-1.291zm-1.574-1.576c-.218.234-.486.352-.838.352h-1.792v-2.18h1.843c.335 0 .602.084.803.319.201.235.302.47.302.754 0 .268-.101.52-.318.755zm.234 3.671c-.218.252-.502.369-.871.369h-1.993v-2.347h1.96c.385 0 .67.1.904.352.235.251.352.503.352.805-.017.301-.117.553-.352.821z" fill="#fff"/></svg>-->
<!--          </a>-->
<!--        </div>-->
        <a href="https://antonov.group/" target="_blank" class="sidebar__icon">
          <img src="@/assets/img/sidebar/poweredbyblue.svg" alt="">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from './Menu'
import auth from '@/http/requests/auth'

export default {
  name: 'Sidebar',
  components: {
    Menu
  },
  data () {
    return {
      links: [
        { id: 1, text: '+7 (928) 014-72-72', url: 'tel:+79280147272', icon: 'phone-icon.svg' },
        { id: 3, text: 'antonov_group', url: 'tg://resolve?domain=antonov_group', icon: 'tg-blue.svg' },
        { id: 2, text: 'support@antonov.group', url: 'mailto:support@antonov.group', icon: 'link-icon.svg' },
        { id: 4, text: 'ПН-ПТ 10:00 - 18:00 (Москва)', url: '', icon: 'time-blue.svg' },
      ],
      showMenu: true,
      wWidth: window.innerWidth <= 1100,
      user: localStorage.getItem('user'),
    }
  },
  computed: {
    sidebarOpen() {
      return this.wWidth <= 1100
    },
    sysInfo() {
      return this.$store.state.admin.sysInfo
    },
  },
  methods: {
    toggleSidebar () {
      this.$store.commit('sidebarToggle')
    },
    sidebarMobileClose() {
      if (this.$store.state.sidebarOpen) this.$store.commit('sidebarMobileToggle')
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    logout() {
      auth.logout()
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style lang="sass">
@import "@/assets/common/index.scss"

.sidebar
  position: fixed
  top: 0
  left: 0
  z-index: 99
  width: 300px
  height: 100%
  padding-bottom: 50px
  background-color: #f8fdff
  box-shadow: 0 4px 14px rgba(172, 196, 206, 0.4)
  transition: width 0.3s, transform 0.3s

  +max-w($laptop_sm)
    transform: translateX(-100%)

.sidebar--mini:not(.sidebar--open)
  width: 92px

  .sidebar__logo
    margin-left: 0
    text-align: center

    img
      &:first-child
        display: none
        max-width: none

      &:last-child
        display: block
        width: 45px
        margin: 0 auto

  .sidebar__block
    display: none

  .sidebar__line
    display: none

  .user__logout
    display: none

  &:hover
    .sidebar__logo
      margin-left: 25px

      img
        &:first-child
          display: block

        &:last-child
          display: none

    .sidebar__block
      display: block

    .sidebar__line
      display: block

    .user__logout
      display: block

  .sidebar__toggler
    display: none

  &:hover
    width: 300px

    .sidebar__toggler
      display: block

    .sidebar__menu
      overflow-y: auto

  .sidebar__menu
    overflow-y: hidden

.sidebar--open
  transform: translateX(0)

.sidebar__logo
  position: relative
  display: block
  margin-left: 25px
  padding: 30px 0
  line-height: 0
  overflow: hidden

  img
    &:first-child
      width: 200px

    &:last-child
      display: none

.sidebar__top
  position: relative

.sidebar__toggler
  position: absolute
  right: 17px
  top: 50%
  z-index: 1
  display: flex
  align-items: center
  justify-content: center
  width: 16px
  height: 16px
  border-radius: 50%
  border: 1px solid $color-theme
  transform: translateY(-50%)

  &::after
    content: ""
    width: 6px
    height: 6px
    border-radius: 50%
    background-color: $color-theme

  &.is-hidden::after
    content: ""

  +max-w($laptop_sm)
    display: none

.sidebar__part
  margin: 22px 0 20px

.sidebar__menu
  height: calc(100vh - 190px)
  padding-bottom: 20px
  overflow-x: hidden
  overflow-y: scroll
  scrollbar-color: $color-theme
  scrollbar-width: thin

  &::-webkit-scrollbar
    width: 2px

  &::-webkit-scrollbar-track
    border-radius: 5px
    background-color: #f2f3f8

  &::-webkit-scrollbar-thumb
    border-radius: 5px
    background-color: $color-theme

.sidebar__line
  width: 80%
  height: 1px
  margin: 10px auto 24px
  background-color: $color-border

.sidebar__line--100
  width: 100%

.sidebar__block
  padding: 0 34px

.sidebar__title
  margin-bottom: 15px
  font-size: 16px
  font-weight: 600

.sidebar__links
  margin-bottom: 22px

.sidebar__link
  display: flex
  align-items: flex-start
  padding: 11px 0
  color: $color-text-base
  text-decoration: none
  transition: color 0.3s

  img
    flex-shrink: 0
    margin-right: 18px

  span
    font-size: 16px

  &[href]:hover
    color: $color-theme

.sidebar__text
  margin-bottom: 25px
  font-size: 16px

.sidebar__text--small-m
  margin-bottom: 5px

.sidebar__close
  position: absolute
  right: 17px
  top: 50%
  z-index: 1
  width: 25px
  height: 25px
  padding: 2px
  cursor: pointer
  transform: translateY(-60%)

  &:before,
  &:after
    content: ''
    position: absolute
    top: 50%
    left: 2px
    width: 20px
    height: 2px
    border-radius: 1px
    background-color: $color-theme

  &:before
    transform: rotate(45deg)

  &:after
    transform: rotate(-45deg)

  +min-w($laptop_sm)
    display: none

.sidebar__user
  position: relative
  z-index: 5
  border-top: 1px solid #E7EEF4
  border-bottom: 1px solid #E7EEF4
  box-shadow: -15px 8px 11px #f8fdff

.user__id
  color: #7c8db0
  font-size: 12px

  b
    margin-right: 3px
    font-weight: 600

.sidebar__icon
  display: inline-block
  line-height: 0
</style>
